import { createReducer } from '@reduxjs/toolkit';
import {
  ERROR_OTP_ALREADYSENT,
  ERROR_OTP_USERBLOCKED,
} from 'components/OtpModal/OtpModal.config';
import { apiRequestFailed, apiRequestSuccess } from 'services/api/api.actions';
import { postOtpCheck, postOtpGenerate } from 'services/otp/otp.config';
import {
  resetOtpErrorsAction,
  resetOtpStateAction,
  setGenerateOtpStateAction,
  setOtpStateAction,
} from './otp.actions';

type InitialState = {
  hasError: boolean;
  hintText: string;
  counterRefresh: number;
  counterCheck: number;
  errorInfos: { [key: string]: unknown };
  jwt: string | null;
};

const initialState: InitialState = {
  hasError: false,
  hintText: '',
  counterRefresh: 0,
  counterCheck: 0,
  errorInfos: {},
  jwt: null,
};

const OtpReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(
      apiRequestSuccess,
      (state, { payload: { resourceId, response } }) => {
        switch (resourceId) {
          case postOtpGenerate:
            state.hasError = false;
            state.errorInfos = {};
            state.counterRefresh = response.data.counterRefresh;
            state.counterCheck = 0;
            state.jwt = response.data.jwt;
            break;

          case postOtpCheck:
            state.hasError = false;
            state.errorInfos = {};
            state.hintText = '';
            state.counterRefresh = response.data.counterRefresh;
            state.counterCheck = response.data.counterCheck;
            state.jwt = null; // reset jwt after successful check
            break;
        }
      },
    )
    .addCase(
      apiRequestFailed,
      (state, { payload: { resourceId, error, requestConfig } }) => {
        const errorInfos = error?.response?.data?.error?.errorInfos;

        switch (resourceId) {
          case postOtpGenerate:
            if (errorInfos.generic && errorInfos.generic.length > 0) {
              let hasErrorTemp = true;
              let errorInfosTemp = errorInfos ?? {};
              const counterCheckTemp = error?.response?.data.counterCheck ?? 4;

              if (errorInfos.generic[0] === ERROR_OTP_USERBLOCKED) {
                state.counterRefresh = 4;
              } else if (errorInfos.generic[0] === ERROR_OTP_ALREADYSENT) {
                state.hintText = requestConfig.data.phoneNumber
                  ? 'text.otp.codeSentOnPhone'
                  : '';
                hasErrorTemp = false;
                errorInfosTemp = {};
              }
              state.hasError = hasErrorTemp;
              state.errorInfos = errorInfosTemp;
              state.counterCheck = counterCheckTemp;
            }

            break;
          case postOtpCheck:
            state.hasError = true;
            state.errorInfos = errorInfos ?? {};
            let errorText = '';

            if (errorInfos.generic) {
              errorText = errorInfos.generic[0];
            }
            if (errorInfos.skebby_validation) {
              errorText = errorInfos.skebby_validation[0];
            }
            state.hintText = errorText;
            state.counterCheck = error?.response?.data.counterCheck ?? 4;
            state.counterRefresh = error?.response?.data.counterRefresh ?? 4;
            break;
        }
      },
    )
    .addCase(resetOtpErrorsAction, (state) => {
      state.hasError = false;
      state.hintText = '';
      state.errorInfos = {};
    })
    .addCase(setOtpStateAction, (state, { payload }) => {
      state.hasError = payload.hasError;
      state.hintText = payload.hintText;
      state.counterCheck = payload.counterCheck;
      if (payload.counterRefresh) {
        state.counterRefresh = payload.counterRefresh;
      }
      state.errorInfos = payload.errorInfos;
    })
    .addCase(setGenerateOtpStateAction, (state, { payload }) => {
      state.hasError = payload.hasError;
      state.hintText = payload.hintText;
      state.counterCheck = payload.counterCheck;
      if (payload.counterRefresh) {
        state.counterRefresh = payload.counterRefresh;
      }
      state.errorInfos = payload.errorInfos;
      state.jwt = payload.jwt;
    })
    .addCase(resetOtpStateAction, (state) => {
      state.hasError = false;
      state.errorInfos = {};
      state.hintText = '';
      state.counterCheck = 0;
      state.counterRefresh = 0;
    }),
);

export default OtpReducer;
